export function ifNotAborted<F extends CallableFunction>(request: AbortController, callback: F): F | (() => void) {
    return request.signal.aborted ? () => {} : callback;
}
